export const unusedModuleDataComponent = (
  <div className="italic padded centered">This module is unused</div>
);
